import { Injectable } from '@angular/core';
import { BroadcastService } from '@shared/services/broadcast/broadcast.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';

@Injectable({
  providedIn: 'root'
})
export class FieldTypeTextParentService {

  constructor(private commonUtilsService: CommonUtilsService,
    private broadcastService: BroadcastService,
    private registerEventService: RegisterMixtapeService,
  ) { }

  configureChanges(child:any){
    let field:any = child.field;
    if(field) {
      child.fieldTypeText.titleField = field.extendedLabel && field.extendedLabel !== ''? field.extendedLabel : field.label;
      field.id = field.fieldId? field.fieldId : this.commonUtilsService.createId();
      if(field.multiline && field.minHeight){
        child.fieldTypeText.minHeight = field.minHeight;
      }
      if(field.fieldContentTypeId === 'titl'){
        field.maxLength = 250;
      }
      if(child.skin ==='icam-red' && !child.isLanding && field.evaluatedValue?.hasReferences && !child.fieldTypeText.references){
        child.fieldTypeText.showReferences = !child.fieldTypeText.showReferences;
      }
      if(field.evaluatedValue?.documents?.length){
        child.fieldTypeText.hasVoiceRecord = true;
        child.fieldTypeText.voiceRecord.name = field.evaluatedValue.documents[0].name
        child.fieldTypeText.acceptAceptation = true;
      }
      if(field.inReport !== null && field.inReport !== undefined){
        child.fieldTypeText.inReport = field.inReport.indexOf('|') === -1? [field.inReport] : field.inReport.split('|')
      }
    }

    if((child.preSelectItem === null || child.preSelectItem === undefined) && child.field.defaultValue){
        child.fieldTypeText.inputText = child.field.defaultValue;
        child.preSelectItem = child.field.defaultValue
        child.itemSelected.emit({newValue: child.fieldTypeText.inputText});
    }else{
        child.fieldTypeText.inputText = child.preSelectItem;
    }
    if(child.concept){
      child.fieldTypeText.lockedSavedConcept = Boolean((child.field.lockedEdit || child.concept.lockedEdit) && (child.concept?.saved))
    }
  }

  enterChangeInField(e:any, child:any){
    if(document.activeElement instanceof HTMLElement){
      document.activeElement.blur();
    }
    if(child.field.addEnter){
        e.preventDefault();
        this.changeInField(child, true);
    }else{
        this.changeInField(child);
    }
  }

  changeInField(child: any, addEnter: any = false){
    this.changeInFieldEmit(child.fieldTypeText.inputText, addEnter, child);
  }

  changeInFieldEmit(newValue: any, addEnter: any = false, child: any){
    child.itemSelected.emit({newValue: newValue, addEnter:addEnter});
    if(newValue && child.field.error){
      child.field.error = false;
      delete child.field.errorText;
    }
    // if(child.field.clean === true){
    //     child.fieldTypeText.inputText = '';
    // }
  }

  resetInput(child: any){
    child.fieldTypeText.inputText = '';
    child.itemSelected.emit({newValue: child.fieldTypeText.inputText});
  }

  showReference(e:any, child:any){
    e.stopPropagation();
    child.fieldTypeText.showReferences = !child.fieldTypeText.showReferences;
  }

  openModalRelatedInfo(e:any, fieldRelatedInfo:any, child:any){
    if(e){
      e.stopPropagation();
      e.preventDefault();
    }
    child.openRelatedInfo.emit({relatedInfo:fieldRelatedInfo});
  }
  openIaAssistance(child:any){

    let registerItem: any = {
      event: 'Field IA ',
      conceptName: sessionStorage.getItem('breadcrumbConcept') + child.concept.title
    }
    this.registerEventService.register(registerItem);
    this.broadcastService.broadcast('saveBeforeIa', {field: child.field, concept: child.concept, action: 'showIaAssistance'});
  }
}
